import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import { capitalize } from 'util/strings'
import { asArray } from 'util/selectors'

import themeVars from 'ui_theme/site/globals/site.variables'

import {
  BarChartVisualization,
  grooveTheme,
} from 'ducks/reports/visualizations'
import {
  selectConversationsCreatedForEachDayGauge,
  selectCustomersForEachDayGauge,
  selectConversationsResolvedForEachDayGauge,
} from 'ducks/reports/gauges'

const { dust, green, purple } = grooveTheme.colors

const selectGauges = createSelector(
  selectConversationsCreatedForEachDayGauge,
  selectCustomersForEachDayGauge,
  selectConversationsResolvedForEachDayGauge,
  asArray
)
const staticSelect = {
  colorScale: [purple, dust, green],
  labelFormatter: (item, itemGauge, gauges) => {
    const timeframeValues = []
    gauges.forEach(set => {
      if (set && set.result) {
        let timeValueItem = {
          value: 0,
        }
        if (set.result) {
          timeValueItem =
            set.result.find(setItem => {
              return (
                setItem.timeframe.start === item.timeframe.start &&
                setItem.timeframe.end === item.timeframe.end
              )
            }) || timeValueItem
        }
        const title = set.title
          .split(' ')
          .map(t => capitalize(t.toLowerCase()))
          .join(' ')

        timeframeValues.push(
          `${title} = ${(timeValueItem && timeValueItem.value) || 0}`
        )
      }
    })
    return timeframeValues.join('\n')
  },
}
const select = (state, props) => ({
  ...staticSelect,
  gauges: selectGauges(state, props),
})
export default connect(select)(BarChartVisualization)
